import { render, staticRenderFns } from "./TicketSupervisorEmpresa.vue?vue&type=template&id=120e4ce1&scoped=true&"
import script from "./TicketSupervisorEmpresa.vue?vue&type=script&lang=js&"
export * from "./TicketSupervisorEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./TicketSupervisorEmpresa.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./TicketSupervisorEmpresa.vue?vue&type=style&index=1&id=120e4ce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e4ce1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
